import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function PaymentCancelPage() {
  const navigate = useNavigate();

  return (
    <div className="max-w-2xl mx-auto text-center fade-in">
      <div className="bg-white rounded-3xl border-2 border-stone-200 p-8 md:p-12">
        <div className="w-20 h-20 bg-stone-100 rounded-full mx-auto mb-6 flex items-center justify-center">
          <XCircle className="w-10 h-10 text-stone-400" />
        </div>
        <h1 className="font-heading font-bold text-2xl md:text-3xl text-text mb-4">
          Payment Cancelled
        </h1>
        <p className="text-text-muted text-lg mb-8">
          No worries! Your payment was cancelled and you haven't been charged. 
          You can try again whenever you're ready.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Button
            onClick={() => navigate('/purchase')}
            className="bg-primary text-white hover:bg-primary-600 rounded-full px-8 py-6 text-lg font-bold"
          >
            Try Again
          </Button>
          <Button
            onClick={() => navigate('/')}
            variant="outline"
            className="rounded-full px-6 py-4 font-semibold"
          >
            Back to Home
          </Button>
        </div>
        <p className="text-text-muted text-sm mt-8">
          Remember, Module 1 is free to try!
        </p>
      </div>
    </div>
  );
}
